export const ERP_SESSION_REDIRECT_URL = '/irp/brand/:virtualBrandId/pack/:virtualPackId';
export const ERP_SESSION_URL = '/irp/pack/:erpPackId/session/:erpSessionId';

export const createErpDetailLink = (virtualBrandId: string, virtualPackId: string) => {
	return ERP_SESSION_REDIRECT_URL.replace(':virtualBrandId', virtualBrandId).replace(':virtualPackId', virtualPackId);
};

export const createErpSessionLink = (erpSessionId: string, erpPackId: string) => {
	return ERP_SESSION_URL.replace(':erpSessionId', erpSessionId).replace(':erpPackId', erpPackId);
};
